// Конфигурация сайта - легко изменяемые данные
export const siteConfig = {
  company: {
    name: 'Фабрика Каркасов Алатау',
    shortName: 'ФКА',
    logo: require('../assets/logo.png'),
    description: 'Производство ЛСТК конструкций в Казахстане'
  },
  contact: {
    phone: '+7 700 384 0505',
    phoneRaw: '+77003840505',
    email: 'FK.Alatau@gmail.com',
    address: 'улица Курмангазы, 1Б,Алматинская область, г.Алатау, мкр.Заречный,B10F7X7',
    workingHours: 'Пн-Пт: 9:00 - 18:00, Сб: 10:00 - 15:00'
  },
  social: {
    whatsapp: 'https://wa.me/77003840505',
    instagram: 'https://www.instagram.com/alatau_lstk',
    facebook: '#'
  },
  location: {
    lat: 43.710918,
    lng: 77.031865,
    zoom: 12,
    mapApiKey: 'AIzaSyB1CDpNW2-7gBu6YtA_zPCl26erVPuXuzc'
  }
};
